import React, {PureComponent} from 'react';
import toastr from 'toastr';

import {getCurrentUserId, getJwt, getCurrentUserName} from '../../../services/authService';
import http from '../../../services/httpService';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import Header from '../Header'
import countries from '../../common/countries.json';

import authService from "../../../services/authService";
// import ReactGA from "react-ga";
import axios from "axios";

class InsertPhone extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            phone: {
                iso2: 'us',
                dialCode: '1',
                phone: ''
            },
            formatedPhone: '',
            fieldsCheckActive: false,
            spinnerActive: false,
            errors: {},
            errorsList: []
        };
    }

    doSubmit = async (type = null) => {
        this.setState({fieldsCheckActive: true})

        let anyErrorActive = await false;
        await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
        // console.log('Iz do submit: ', anyErrorActive, this.state.errorsList, this.state.firstName, this.state.lastName, this.state.country, this.state.formatedPhone, this.state.selectedUsState.abbreviation, this.isPhoneNumber())
        if (!anyErrorActive && this.state.formatedPhone && this.isPhoneNumber()) {
            try {
                const userId = await getCurrentUserId();
                // let index = this.state.data.name.indexOf(" ");  // Gets the first index where a space occurs
                if (userId) {
                    await this.setState({spinnerActive: true});
                    const resp = await http.post('api/user/' + userId + '/register_user_valid_phone', {
                        phone: this.state.formatedPhone,
                    }, {headers: {authorization: getJwt()}});
                    let pinId = resp?.data?.pinId ?? resp?.data?.data?.pinId
                    if(pinId){
                        await this.props.updateUserFromServer();
                        this.props.history.push('/phone-validation',{pinId})

                        this.setState({spinnerActive: false});
                    }else{
                        toastr.warning("Too Many Attempts. Try again later or contact support@emitto.io");
                        this.setState({spinnerActive: false});
                    }

                }
            } catch (ex) {
                this.setState({spinnerActive: false});
                toastr.error("Too Many Attempts. Try again later or contact support@emitto.io");
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    //console.log(ex.response.data);
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
            }
        }
    };

    getUserData = async () => {
        const userId = await getCurrentUserId();
        if (userId) {
            try {
                // const result = await http.get('api/user/' + userId, { headers: { authorization: getJwt() } });
                const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                const data = await result.data.data;
                if (data !== this.state.user) {
                    await this.setState({user: data})
                    // console.log('userData: ', data)
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    //console.log("User Something went wrong... Please refresh and try again.");
                    this.props.history.push('/logout');
                if (ex.response && ex.response.status === 401) {
                    //    let errors = { ...this.state.errors }
                    //console.log(ex.response.data);
                    //console.log(ex.response.data.message);
                    //window.location = "/";
                    this.props.history.push('/logout');
                }
            }
        }
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
        // console.log('Errors list data: ', error, id, errorsList);
    }

    getFullPhoneNumber = (phoneObject) => {
        let phone = phoneObject.phone.toString();
        let dialCode = phoneObject.dialCode;

        if (phone.startsWith('00')) {
            phone = phone.substring(2);
            phone = '+' + phone;
            return phone
        } else if (phone.startsWith('0')) {
            phone = phone.substring(1);
            phone = '+' + dialCode + phone;
            return phone
        } else if (phone.startsWith('+')) {
            return phone
        } else if (phone && (phone !== '+')) {
            phone = '+' + dialCode + phone;
            return phone
        } else {
            return ''
        }
    }

    isPhoneNumber = () => {
        let phone = this.state.formatedPhone;
        var regEx = /^[+-]?\d+$/;
        if (regEx.test(phone) && phone.length > 6) {
            return true
        } else {
            return false
        }
    }

    async componentDidMount() {
        // ReactGA.pageview(window.location.pathname + window.location.search);
        await this.getUserData();

        if (this.state.user && this.state.user.active === 0) {
            this.props.history.push('email-verification')
        } else if (this.state.user && this.state.user.country) {
            // console.log('country: ', this.state.user.country)
            let selectedCountry = countries.find(country => country.code === this.state.user.country)
            // console.log('selectedCountry: ', this.state.user.country)
            if (selectedCountry && (this.state.user.country !== 'AQ')) {
                this.setState({
                    phone: {
                        iso2: selectedCountry.code,
                        dialCode: selectedCountry.dial_code,
                        phone: this.props.user.phone || ''
                    },
                    formatedPhone: this.props.user.phone || ''
                })
            }
            // console.log('phone in state: ', this.state.phone)
        }
    }

    render() {
        let addPlus = this.state.phone.dialCode ? !this.state.phone.dialCode.includes('+') : false
        const inputProps = {
            placeholder: addPlus ? '+' + this.state.phone.dialCode + ' *********' : '' + this.state.phone.dialCode + ' *********',
        };

        const intlTelOpts = {
            preferredCountries: [],
        };
        const onReady = (instance, IntlTelInput) => console.log('');
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title m-xxl-b'>What is your phone number?</h1>

                        <p htmlFor="post-link" className='full-row-label'>Phone</p>
                        <ReactIntlTelInput
                            className={((this.state.phone.phone === '') || !this.isPhoneNumber()) && this.state.fieldsCheckActive ? 'onboard-tel error' : this.state.phone.phone === '' ? '' : 'onboard-tel valid'}
                            inputProps={inputProps}
                            intlTelOpts={intlTelOpts}
                            value={this.state.phone}
                            onChange={(e) => {
                                this.setState({
                                    phone: e,
                                    formatedPhone: this.getFullPhoneNumber(e)
                                })
                            }}
                            onReady={onReady}
                        />
                        {
                            ((this.state.phone.phone === '') || !this.isPhoneNumber()) && this.state.fieldsCheckActive ?
                                <div className="selector-error-label">Valid phone number is required</div>
                                :
                                <div className='selector-error-label'></div>
                        }
                        {this.state.spinnerActive ?
                            <button className='btn-action btn-spinner'>Verify <i className='fa fa-spin fa-spinner'></i>
                            </button>
                            :
                            <button className='btn-action' onClick={this.doSubmit}>Verify</button>
                        }

                        <div className='panel-message'>
                            <p>By registering on our website you are agreeing to our <a target='_blank'
                                                                                        href="https://emitto.io/terms-of-service">Customer
                                Terms of Service,
                                Privacy Policy, Cookie Policy.
                            </a></p>
                        </div>
                    </div>
                    {/*{console.log('formatedPhone: ', this.state.formatedPhone)}*/}
                </div>

            </div>
        )
    }
}

export default InsertPhone;